module.exports = __webpack_public_path__ + "static/media/provider-admin-active.50f73d38.svg";